/**
 * Native sharing with a copy-to-clipboard fallback.
 *
 * @package DemocraticTools
 */

const feedbackTimers = new WeakMap();

function showShareFeedback(feedback, message) {
  if (!feedback) {
    return;
  }

  feedback.hidden = false;
  feedback.textContent = message;

  const previous = feedbackTimers.get(feedback);
  if (previous) {
    globalThis.clearTimeout(previous);
  }

  const timer = globalThis.setTimeout(() => {
    feedback.hidden = true;
    feedback.textContent = "";
    feedbackTimers.delete(feedback);
  }, 2200);

  feedbackTimers.set(feedback, timer);
}

export function initContentShare() {
  document.querySelectorAll("[data-share-url]").forEach((button) => {
    if (button.tagName !== "BUTTON") {
      return;
    }

    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const url = button.getAttribute("data-share-url") || "";
      const title = button.getAttribute("data-share-title") || document.title;
      const action = button.getAttribute("data-share-action") || "copy";
      const label = button.getAttribute("data-share-label") || "Link copied";
      const container = button.closest(".dt-content-share, .dt-article-card");
      const feedback = container
        ? container.querySelector("[data-share-feedback]")
        : null;

      if (url === "") {
        return;
      }

      if (action === "share" && typeof navigator.share === "function") {
        try {
          await navigator.share({ title, url });
          showShareFeedback(feedback, label);
          return;
        } catch (error) {
          if (error instanceof Error && error.name === "AbortError") {
            return;
          }
        }
      }

      try {
        await navigator.clipboard.writeText(url);
        showShareFeedback(feedback, label);
      } catch {
        showShareFeedback(feedback, url);
      }
    });
  });
}
